import type { ReactNode } from 'react';
import { usePageMeta } from '@/hooks/usePageMeta';

interface PageMetaProps {
  title: string;
  description: string;
  keywords: string;
  children: ReactNode;
}

export default function PageMeta({ title, description, keywords, children }: PageMetaProps) {
  usePageMeta(title, description, keywords);
  return <>{children}</>;
}